import axios from 'axios'
import { Auth } from 'aws-amplify'

const axiosClient = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    'https://4gmhhyk418.execute-api.eu-central-1.amazonaws.com/dev',
})

axiosClient.defaults.headers.common['Content-Type'] = 'application/json'
axiosClient.defaults.headers.post['Content-Type'] = 'application/json'
axiosClient.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

let isRefreshing = false
let failedQueue = []

export const setAuthHeader = (token) => {
  axiosClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const refreshAuthToken = async () => {
  // TODO: Refactor route wrapper and other auth flow.
  const session = await Auth.currentSession()
  const idToken = session.getIdToken()

  const {
    data: { token },
  } = await axiosClient.post('/user/token', {
    cognitoID: idToken.payload.sub,
    cognitoToken: session.getAccessToken().getJwtToken(),
  })
  setAuthHeader(token)

  return token
}

// Retry requests after refreshing token, or reject if token refresh fails.
function processQueue(error, token = null) {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

axiosClient.interceptors.response.use(
  (response) => ({ ...response, ok: true }),
  // If our auth token expires, we queue requests, refresh the token, and then retry the requests.
  async (error) => {
    const originalRequest = error.config

    if (
      !originalRequest ||
      error.response?.status !== 401 ||
      originalRequest._retry ||
      originalRequest.url.endsWith('/user/token') // Prevent loop if refresh 401s.
    ) {
      return Promise.reject(error)
    }

    originalRequest._retry = true

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      }).then((token) => {
        setAuthHeader(token)
        // Directly changing the header makes sure the retried request uses the new token.
        originalRequest.headers['Authorization'] = `Bearer ${token}`
        return axiosClient(originalRequest)
      })
    }

    isRefreshing = true

    return new Promise((resolve, reject) => {
      refreshAuthToken()
        .then((newToken) => {
          setAuthHeader(newToken)
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`
          processQueue(null, newToken)
          resolve(axiosClient(originalRequest))
        })
        .catch((err) => {
          processQueue(err, null)
          window.location.href = '/login'
          reject(err)
        })
        .finally(() => {
          isRefreshing = false
        })
    })
  },
)

export default axiosClient
